/**
 * TIP Shell — browser entry point (the esbuild bundle target). Side-effecting: it
 * boots the Shell into #app. Programmatic consumers should import from ./index.js
 * instead (no auto-boot).
 */
import { mountShell } from './bootstrap.js';

const rootEl = document.getElementById('app');
if (rootEl) void mountShell(rootEl);
